module.exports = __webpack_public_path__ + "03_mustache_grey.de4127b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/papa/layer3/03_mustache_grey.png
// module id = NTE8
// module chunks = 0